import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { purple } from '@mui/material/colors';
import Link from '@mui/material/Link';
import Div from '@jumbo/shared/Div';
import { alpha } from '@mui/material/styles';
import { ASSET_IMAGES } from '../../../utils/constants/paths';
import { getAssetPath } from '../../../utils/appHelpers';
import * as yup from 'yup';
import { Form, Formik } from 'formik';
import JumboTextField from '@jumbo/components/JumboFormik/JumboTextField';
import LoadingButton from '@mui/lab/LoadingButton';
import { useNavigate } from 'react-router-dom';
import JumboPasswordField from '@jumbo/components/JumboFormik/JumboPasswordField';
import { loginUser } from 'app/redux/slice/authSlice';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import { useCookies } from 'react-cookie';
import { getAllowedPermissions } from 'app/redux/slice/roleSlice';

const validationSchema = yup.object({
  email: yup
    .string('Enter your email')
    .email(
      'Please enter a valid email address in the format example@domain.com',
    )
    .required('Email is required'),
  password: yup.string('Enter your password').required('Password is required'),
});
const Login = ({ disableSmLogin }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  // eslint-disable-next-line no-unused-vars
  const [cookies, setCookie] = useCookies(['access_token']);

  const onSignIn = (data) => {
    dispatch(loginUser(data))
      .unwrap()
      .then((res) => {
        if (res?.status === 200) {
          setCookie('access_token', res.data.data.token, {
            path: '/',
            secure: false,
            sameSite: 'strict',
          });
          localStorage.setItem('User', JSON.stringify(res.data.data.user));          
          dispatch(getAllowedPermissions(res.data.data.user.roleId._id))
            .unwrap()
            .then((response) => {
              if (response?.status === 200) {
                if (response?.data?.data?.rolePermissions) {
                  localStorage.setItem(
                    'permission',
                    JSON.stringify(
                      response?.data?.data?.rolePermissions?.permissionId,
                    ),
                  );
                }
                if(res.data.data.user.roleId.slug === 'master-admin'){
                  window.location.href = "/users";
                }else{
                  window.location.href = "/";
                }
              }
            });
          
          // navigate('/users');
        } else {
          enqueueSnackbar(res.data?.responseMessage, { variant: 'error' });
        }
      });
  };
  const color = purple[500];

  return (
    <Div
      sx={{
        width: 720,
        maxWidth: '100%',
        margin: 'auto',
        p: 4,
      }}
    >
      <Card
        sx={{
          display: 'flex',
          minWidth: 0,
          flexDirection: { xs: 'column', md: 'row' },
        }}
      >
        <CardContent
          sx={{
            flex: '0 1 300px',
            position: 'relative',
            background: `#d3d04f no-repeat center`,
            backgroundSize: 'cover',
            '&::after': {
              display: 'inline-block',
              position: 'absolute',
              content: `''`,
              inset: 0,
              backgroundColor: alpha('#d3d04f', 0.6),
            },
          }}
        >
          <Div
            sx={{
              display: 'flex',
              minWidth: 0,
              flex: 1,
              flexDirection: 'column',
              color: 'common.white',
              position: 'relative',
              zIndex: 1,
              height: '100%',
            }}
          >
            <Div sx={{ mb: 2 }}>
              <Typography
                variant={'h3'}
                color={'#213363'}
                fontWeight={500}
                mb={3}
              >
                Sign In
              </Typography>
              <Typography color={'#213363'} variant={'body1'} mb={2}>
                By signing in, you can access your TSM Panel.
              </Typography>
            </Div>
            <Div sx={{ mt: 'auto' }}>
              <Link href="#" underline="none" sx={{ display: 'inline-flex' }}>
                <img
                  style={{ width: '135px' }}
                  src={`${ASSET_IMAGES}/tsm-logo.png`}
                  alt="Jumbo React"
                />
              </Link>
            </Div>
          </Div>
        </CardContent>
        <CardContent sx={{ flex: 1, p: 4 }}>
          <Formik
            validateOnChange={true}
            initialValues={{
              email: '',
              password: '',
            }}
            validationSchema={validationSchema}
            onSubmit={(data, { setSubmitting }) => {
              setSubmitting(true);
              onSignIn(data);
              setSubmitting(false);
            }}
          >
            {({ isSubmitting }) => (
              <Form style={{ textAlign: 'left' }} noValidate autoComplete="off">
                <Div sx={{ mt: 1, mb: 3 }}>
                  <JumboTextField fullWidth name="email" label="Email" />
                </Div>
                <Div sx={{ mt: 1, mb: 2 }}>
                  <JumboPasswordField
                    fullWidth
                    name="password"
                    label="Password"
                    type="password"
                  />
                </Div>
                <LoadingButton
                  fullWidth
                  type="submit"
                  variant="contained"
                  size="large"
                  sx={{ mb: 2 }}
                  loading={isSubmitting}
                >
                  Sign In
                </LoadingButton>
                {!disableSmLogin && (
                  <React.Fragment>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      mb={1}
                    >
                      {/* <Typography variant={'body1'}>
                        <Link
                          href={'/reset-password'}
                          color={color}
                          underline={'none'}
                        >
                        Forgot password?
                        </Link>
                      </Typography> */}
                    </Box>
                    {/* <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Typography variant={'body1'}>
                        Don't have an account yet?&nbsp;
                        <Link
                          href={'/auth-pages/signup'}
                          color={color}
                          underline={'none'}
                        >
                          register
                        </Link>
                      </Typography>
                    </Box> */}
                  </React.Fragment>
                )}
              </Form>
            )}
          </Formik>
        </CardContent>
      </Card>
    </Div>
  );
};
export default Login;
